import PurchaseConfirmationModalBid from './purchaseConfirmationModalBid'

export default PurchaseConfirmationModalBid
